import { DATA_URL_SAVED } from '../../constants';

/*
 * отправка данных
 */

function parseData(data) {
  let result = '';

  Object.keys(data).forEach((key) => {
    let current = data[key];

    if (typeof current !== typeof '') {
      current = JSON.stringify(current);
    }

    result = `${result}&${key}=${current}`;
  });

  return result;
}

export default function (data, sessionId) {
  const send = async (body, timer) => {
    const response = await fetch(`${DATA_URL_SAVED}${body}&timestamp=${Date.now()}`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (response.status !== 200) {
      setTimeout(() => {
        send(body, timer * 2);
      }, timer);
    }
  };

  const body = `?sesid=${sessionId}${parseData(data)}`;

  send(body, 7000);
}



// WEBPACK FOOTER //
// ./src/lib/sender/index.js